export default __webpack_public_path__ + "static/partner1-e80f7596b45eb131a2741853d44e00e9.png";